import { render, staticRenderFns } from "./LpFinalCard.vue?vue&type=template&id=20c99d6f"
import script from "./LpFinalCard.vue?vue&type=script&lang=js"
export * from "./LpFinalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports